
  import { reactive } from "vue";
  import { Options, Vue } from "vue-class-component";
  import { IReCaptchaComposition, useReCaptcha } from "vue-recaptcha-v3";
  import { useVuelidate } from "@vuelidate/core";
  import { required, email } from "@vuelidate/validators";
  import { helpers } from "@vuelidate/validators";
  export default class ContactForm extends Vue {
    formSubmission = false;
    isSubmitting = false;
    formData = reactive({
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      // department: "",
      region: "",
      message: "",
    });
    regionOptions = [
      {
        value: "Eastern Cape",
        label: "Eastern Cape",
      },
      {
        value: "Free State",
        label: "Free State",
      },
      {
        value: "Gauteng",
        label: "Gauteng",
      },
      {
        value: "KwaZulu-Natal",
        label: "KwaZulu-Natal",
      },
      {
        value: "Limpopo",
        label: "Limpopo",
      },
      {
        value: "Mpumalanga",
        label: "Mpumalanga",
      },
      {
        value: "Northern Cape",
        label: "Northern Cape",
      },
      {
        value: "North West",
        label: "North West",
      },
      {
        value: "Western Cape",
        label: "Western Cape",
      },
    ];
    // departmentOptions = [
    //   {
    //     value: "CustomerCare",
    //     label: "Customer Care",
    //   },
    //   {
    //     value: "SpareParts",
    //     label: "Spare Parts",
    //   },
    //   {
    //     value: "Repairs",
    //     label: "Service Centre and Repairs",
    //   }
    // ];
    recapthcaObject: IReCaptchaComposition | undefined = undefined;
    veulidate: any;
    self = this;
    rules = {
      formData: {
        firstName: {
          required,
        },
        lastName: {
          required,
        },
        email: {
          required,
          email,
        },
        phoneNumber: {
          phoneNumber: helpers.regex(/^[0-9 \-]+$/),
        },
        // department: {
        //   required,
        // },
        region: {
        },
        message: {
          required,
        },
      },
    };
    created() {
      this.recapthcaObject = useReCaptcha() as IReCaptchaComposition;
      this.veulidate = useVuelidate(this.rules.formData, this.formData);
    }
    get v$() {
      if (this.veulidate) {
        return this.veulidate.value;
      }
      return null;
    }
    async recaptcha() {
      if (this.recapthcaObject) {
        this.$emit('loading', true)
        // Wait until recaptcha has been loaded.
        await this.recapthcaObject.recaptchaLoaded();
        // Execute reCAPTCHA with action
        const token = await this.recapthcaObject.executeRecaptcha(`${process.env.VUE_APP_FORM_KEY_CONTACT}`);
        // Do stuff with the received token.
        this.$emit('loading', false)
        this.sendQuery(token);
      }
    }
    async validate() {
      this.$emit('loading', true)
      this.isSubmitting = true;
      if (this.v$.$invalid) {
        this.v$.$touch();
        this.$notify({ type: "error", text: 'Please complete all required fields.', ignoreDuplicates: true, duration: -1 });
        this.isSubmitting = false;
        this.$emit('loading', false)
        return;
      }
      this.recaptcha();
    }
    async sendQuery(recaptchaResult: string) {
      this.$emit('loading', true)
      const FormContent = this.formData;
      const formKey = process.env.VUE_APP_FORM_KEY_CONTACT || "";
      const endpoint = process.env.VUE_APP_FORM_ENDPOINT ? process.env.VUE_APP_FORM_ENDPOINT+ "/api/forms/" + formKey : "";
      const store_only = process.env.VUE_APP_FORM_STORE_ONLY === 'true' ? true : false;
      const email = this.formData.email
      
      const options: any = {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          GoogleRecaptchaResponse: recaptchaResult,
          FormContent,
          StoreOnly: store_only,
          EmailAddress: email
        }),
      };
      try {
        const res = await fetch(endpoint, options).then((result) => {
          if (result.status === 200) {
            this.formSubmission = true;
            //window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
            this.$emit('loading', false)
            return result;
          } else {
            this.isSubmitting = false;
            this.$emit('loading', false)
            this.$notify({ type: "error", text: 'Error submitting contact form.', ignoreDuplicates: true, duration: -1 });
          }
        });
      } catch (e: any) {
        this.isSubmitting = false;
        this.$emit('loading', false)
        this.$notify({ type: "error", text: `Error submitting contact form. ${e}`, ignoreDuplicates: true, duration: -1 });
        throw new Error(e);
      }
    }
  }
